import FileUploader from "./FileUploader";
import React from "react";
import WarningPopup, {useWarningState} from "./WarningPopup";

const DocsFileUploader: React.FC<{
    file: File | null,
    setFile: (file: File | null) => void
}> = (props) => {
    const warningStateFile = useWarningState<boolean>(false)
    
    function changeFile(file: File) {
        props.setFile(file);
    }

    function showExistingFile() {
        const file = props.file;
        if (file == null) return null
        return <div className="flex items-center p-3 justify-between">
            <div className="pr-4">{file.name}</div>
            <span
                onClick={() => warningStateFile.show(`Are you sure you want to delete this file? ${file.name}`, true)}
                className="btn-error btn-sm">x</span>
        </div>
    }
    

    return <div>
        {
            showExistingFile()
        }

        <div className="p-3">
            <FileUploader onChange={f => changeFile(f)}>
            </FileUploader>
        </div>

        <WarningPopup state={warningStateFile} onYes={() => {
            props.setFile(null)
        }}/>
    </div>
}

export default DocsFileUploader;